import { getFetch, postFetch, putFetch, deleteFetch } from '../utils/fetch';
import { LEGAL_DOCUMENT_API } from './config';

export function getList(query) {
  return getFetch(`${LEGAL_DOCUMENT_API()}`, query);
}

export function getOne(_id) {
  return getFetch(`${LEGAL_DOCUMENT_API()}/${_id}`);
}

export function updateOne(_id, data = {}) {
  return putFetch(`${LEGAL_DOCUMENT_API()}/${_id}`, data);
}

export function deleteOne(_id) {
  return deleteFetch(`${LEGAL_DOCUMENT_API()}/${_id}`);
}

export function create(obj) {
  return postFetch(`${LEGAL_DOCUMENT_API()}`, obj);
}

export function getSearchList(query) {
  return getFetch(`${LEGAL_DOCUMENT_API()}`, {
    search: query,
    field: ['FacilityNameFull'],
    page: 1,
    itemPerPage: 10,
  });
}

export function getAll() {
  return getFetch(`${LEGAL_DOCUMENT_API()}/getAll`);
}

export function exportData(query) {
  return getFetch(`${LEGAL_DOCUMENT_API()}/export`, {
    ...query,
  });
}

export function exportDataWithIds(query) {
  return postFetch(`${LEGAL_DOCUMENT_API()}/exportWithQuery`, {
    ...query,
  });
}

// DETAIL

export function getAuditDetail(_id) {
  return getFetch(`${LEGAL_DOCUMENT_API()}/${_id}/detail`);
}

export function getOneAuditDetail(_id) {
  return getFetch(`${LEGAL_DOCUMENT_API()}/detail-child/${_id}`);
}

export function updateOneAuditDetail(_id, data = {}) {
  return putFetch(`${LEGAL_DOCUMENT_API()}/detail-child/${_id}`, data);
}




// WEBPACK FOOTER //
// ./src/api/legalDocumentApi.js